import { routes } from 'lib/routes';

import { apiSlice } from 'api/base_slice';
import { PARTICIPANTS_TAG, ORGANIZATION_HUB_USAGE_TAG } from 'api/tag_types';
import {
  ACCEPT_V2_HEADER,
  deserializeJSONApiResponse,
  headersAndCredentials,
} from 'api/utils';

export const participantsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getParticipant: builder.query({
      query: ({ id, params }) => routes.api_participant_path(id, params),
      providesTags: (result, error, { id }) => [{ type: PARTICIPANTS_TAG, id }],
      transformResponse: deserializeJSONApiResponse,
      mockRoute: routes.api_participant_path(':id'),
    }),
    updateParticipant: builder.mutation({
      query: ({ id, params }) => ({
        url: routes.api_participant_path(id),
        method: 'PATCH',
        body: params,
        ...headersAndCredentials(),
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: PARTICIPANTS_TAG, id },
      ],
    }),
    upsertParticipants: builder.mutation({
      query: ({ email, populationPanelIds, populationId }) => {
        const params = { data: { attributes: { email } } };

        if (populationPanelIds)
          params.data.population_panel_ids = populationPanelIds;

        return {
          url: routes.api_participants_path({
            participant_population_id: populationId,
          }),
          method: 'PATCH',
          body: params,
          ...headersAndCredentials(ACCEPT_V2_HEADER),
        };
      },
      invalidatesTags: [ORGANIZATION_HUB_USAGE_TAG],
    }),
  }),
  overrideExisting: 'throw',
});

export const {
  mockGetParticipant,
  useGetParticipantQuery,
  useUpdateParticipantMutation,
  useUpsertParticipantsMutation,
} = participantsApi;
